import { slugify } from './slugify'
import { cleanProductLabel } from './displayText'

/**
 * SEO-venlig produkt-URL: /products/babolat-counter-veron-26-2026-925
 * ID i slutningen sikrer unik opslag.
 */
export function productPath(product) {
  if (!product?.id) return '/bat'
  const brand = slugify(product.brand || 'brand')
  const model = slugify(cleanProductLabel(product.model || product.name || 'produkt'))
  const yearPart = product.year ? String(product.year) : ''
  const parts = [brand, model]
  if (yearPart && !model.endsWith(yearPart)) {
    parts.push(yearPart)
  }
  return `/products/${parts.join('-')}-${product.id}`
}

export function parseProductIdFromSlug(slugOrId) {
  const s = String(slugOrId || '').trim()
  if (/^\d+$/.test(s)) return s
  const m = s.match(/-(\d+)$/)
  return m ? m[1] : s
}
